import store from "../../../store/store";
import constants from "../../../utils/constants";
import axios from "../../axios";
// Token Refresh
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
	subscribers = subscribers.filter((callback) => callback(access_token));
}

function addSubscriber(callback) {
	subscribers.push(callback);
}

function buildUrl (url, parameters) {
    let qs = '';
    for (const key in parameters) {
      if (parameters.hasOwnProperty(key)) {
        const value = parameters[key];
        qs += encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
      }
    }
    if (qs.length) {
      qs = qs.substring(0, qs.length - 1); //chop off last "&"
      url = url + '?' + qs;
    }
    return url;
  }

export default {
	createOrder(payload) {
		console.log('payload: ', payload);
		return axios.post(constants.API.PRODUCTS.ORDER_CREATE, payload);
	},
	cancelOrder(payload) {
		return axios.post(constants.API.PRODUCTS.ORDER_CANCEL, payload);
	},
	getListProducts(payload) {
		return axios.get(constants.API.PRODUCTS.LIST, payload);
	},
	getListSuppliers(payload) {
		return axios.get(constants.API.SUPPLIERS.LIST, payload);
	},
	getPlaces(payload) {
		return axios.get(constants.API.PLACES.LIST, payload);
	},
	getOrdersByProduct(id) {
		return axios.get(`${constants.API.PRODUCTS.ORDERS_BY_PRODUCT}/${id}`, null);
	},
	getPaymentNos(payload) {
		let str = '';
		let id = 0;
		if (typeof payload === 'object') {
			id = payload.id;
			payload.s = 2;
			str = buildUrl('', payload);//'?p='+payload.payno_text+'&s=2';
		} else {
			id = payload;
		}
		return axios.get(`/api/get-payment-nos/${id}${str}`, payload);
	},
	getMatchingSells(id) {
		return axios.get(`${constants.API.MATCHINGS.MATCH_PRICE}/${id}`, null);
	},
	getMatching(id) {
		return axios.get(`${constants.API.MATCHINGS.BY_ID}/${id}`, null);
	},
	getShippingFileById(id) {
		return axios.get(`/api/shipping-files-by-id/${id}`, null);
	},
	getDashboardOrder() {
		return axios.get(`/api/dashboard/orders-list`, null);
	},
	getDashbboardSuggest() {
		return axios.get(`/api/dashboard/suggests-list`, null);
	},
	getDashboardSellList(payload) {
		// return axios.get(`/api/dashboard/sells-list`, null);
		let str = str = buildUrl('', payload);//'?p='+payload.payno_text+'&s=2';
		return axios.get(`/api/dashboard/sells-list${str}`, payload);
	},
	getDashboardBuyList(payload) {
		// return axios.get(`/api/dashboard/buys-list`, null);
		let str = str = buildUrl('', payload);//'?p='+payload.payno_text+'&s=2';
		return axios.get(`/api/dashboard/buys-list${str}`, payload);
	},
	getDashboardMatching() {
		return axios.get(`/api/dashboard/top-matching`, null);
	},
	getDashboardNewOrder() {
		return axios.get(`/api/dashboard/orders-list`, null);
	},
	getDashboardPriceHistories(payload) {
		return axios.get(`/api/dashboard/product-price-history?productId=${payload.id || 0}&dateType=${payload.type}`, null);
	},
	getOverviewOrder(payload) {
		return axios.post(`/api/orders-by-me/0`, payload);
	},
	getDistricts(id) {
		return axios.get(`${constants.API.PLACES.DISTRICTS}/${id}`, null);
	},
	getProvinces() {
		return axios.get(`${constants.API.PLACES.PROVINCES}`, null);
	},
	getShipping(id) {
		return axios.get(`${constants.API.MATCHINGS.GET_SHIPPING_BY_ID}/${id}`, null);
	},
	getShippingsByPmid(id) {
		return axios.get(`/api/get-shippings-by-pmid/${id}`, null);
	},
	getOrderById(id) {
		return axios.get(`${constants.API.PRODUCTS.ORDER_BY_ID}/${id}`, null);
	},
	getPoById(id) {
		return axios.get(`/api/po-by-id/${id}`, null);
	},
	getListMatchings(payload) {
		return axios.get(`${constants.API.MATCHINGS.LIST}/${payload.id}?page=${payload.page}&limit=${payload.limit}`, payload);
	},
	getListShippings(payload) {
		let str = str = buildUrl('', payload);//'?p='+payload.payno_text+'&s=2';
		return axios.get(`${constants.API.MATCHINGS.LIST_SHIPPINGS}/${payload.id}${str}`, payload);
		// return axios.get(`${constants.API.MATCHINGS.LIST_SHIPPINGS}/${payload.id}?page=${payload.page}&limit=${payload.limit}&search=${payload.search}&type_variant=${(payload.type_variant || false)}&types=${payload.types || null}`, payload);
	},
	// getOrdersByMe(payload) {
	// 	return axios.get(`${constants.API.PRODUCTS.ORDERS_BY_ME}/${payload.id}?page=${payload.page}&limit=${payload.limit}&sort=${payload.sort}`, payload);
	// },
	getOrdersByMe(payload) {
		return axios.post(`${constants.API.PRODUCTS.ORDERS_BY_ME}/${payload.id}`, payload);
	},
	getSellsList(payload) {
		return axios.post(`${constants.API.PRODUCTS.SELLS_LIST}`, payload);
	},
	saveShipping(payload) {
		return axios.post(constants.API.MATCHINGS.SAVE_SHIPPING, payload);
	},
	confirmBuy(payload) {
		return axios.post(constants.API.MATCHINGS.CONFIRM_BUY, payload);
	},
	doneShipping(payload) {
		return axios.post(constants.API.MATCHINGS.DONE_SHIPPING, payload);
	},
	kcsReviewShipping(payload) {
		return axios.post(constants.API.MATCHINGS.KCS_REVIEW_SHIPPING, payload);
	},
	saveSo(payload) {
		return axios.post('/api/sos/save', payload);
	},
	getSos(payload) {
		return axios.post('/api/sos/list', payload);
	},
	
	setPaymentInfo(payload) {
		return axios.post(constants.API.MATCHINGS.PAYMENT_INFO, payload);
	},
	setPaymentInfoAqua(payload) {
		return axios.post(constants.API.MATCHINGS.PAYMENT_INFO_AQUA, payload);
	},
	ratingBuyer(payload) {
		return axios.post(constants.API.MATCHINGS.RATING_BUYER, payload);
	},
};
